import { defineMessages } from 'react-intl';

export const searchFormLabels = defineMessages({
  searchValue: {
    description: 'ordersPage.search.labels.search-value',
    defaultMessage: 'Search Orders...',
    id: 'b4qJaK',
  },
  searchWithin: {
    description: 'ordersPage.search.labels.search-within',
    defaultMessage: 'Search Within',
    id: 'cXG7ey',
  },
  dateRange: {
    description: 'ordersPage.search.labels.date-range',
    defaultMessage: 'Date Range',
    id: '3bVLSu',
  },
  applySearch: {
    description: 'ordersPage.search.labels.apply-search',
    defaultMessage: 'Apply Search',
    id: 'tRaYgv',
  },
  unselectedOption: {
    description: 'ordersPage.search.labels.unselectedOption',
    defaultMessage: 'Please Select',
    id: 'VUXPsU',
  },
});
